<template>
  <div>
    <div class="loan-container">
      <h4 class="header mt-5">Disbursements</h4>
      <p class="subText mb-5">
        Disbursements helps you to keep track of all the loan disbursements
        you've made over time.
      </p>

      <div class="loan-container__header-card pt-5 mb-5">
        <div class="header">
          <div class="header-left">
            <h2 class="text">Overview</h2>
            <p class="sub-text">
              Here’s a quick overview of what’s happening
            </p>
          </div>
          <div class="filter__wrap" @click.stop>
            <div
              class="filter-selected"
              @click="showFilterMenu = !showFilterMenu"
            >
              {{ filter.text }}
              <svgicon
                icon="drop-down"
                :class="`filter-icon ${showFilterMenu && 'active'}`"
              ></svgicon>
            </div>
            <ul
              v-if="showFilterMenu"
              :class="`header-filter ${showFilterMenu && 'active'}`"
            >
              <li
                v-for="(el, index) in filterOption"
                :key="index"
                @click="handleFilter(el)"
              >
                {{ el.text }}
              </li>
            </ul>
          </div>
        </div>

        <div class="repayment-container">
          <div class="disbursement-container">
            <div class="inner-elements">
              <div class="border-right">
                Lorem ipsum dolor sit amet.
              </div>
              <div class="request-container">
                <div>
                  <h3>₦0</h3>

                  <p class="link">View all requests</p>
                </div>
              </div>
            </div>
          </div>
          <div class="wallet-container">
            <p class="wallet-header">Total Wallet Balance</p>

            <h3 class="wallet-value">₦ 0</h3>
            <hr />

            <div class="wallet-footer">
              <div>
                <p class="wallet-header">Disbursed</p>

                <h3 class="wallet-value">₦ 0</h3>
              </div>
              <div>
                <p class="wallet-header">Repayments</p>

                <h3 class="wallet-value">₦ 0</h3>
              </div>
            </div>
          </div>
        </div>
      </div>

      <h4 class="list-loans-header">All Disbursements</h4>
      <p class="list-loans-subText">
        Disbursements helps you to keep track of all the loan disbursements
        you've made over time.
      </p>

      <div class="loan-container__header-card">
        <div class="header">
          <div class="table-filter" @click.stop>
            <div
              class="filter-selected"
              @click="showRequestFilterMenu = !showRequestFilterMenu"
            >
              {{ requestFilter.text }}
              <svgicon
                icon="drop-down"
                :class="`filter-icon ${showRequestFilterMenu && 'active'}`"
              ></svgicon>
            </div>
            <ul
              v-if="showFilterMenu"
              :class="`header-filter ${showRequestFilterMenu && 'active'}`"
            >
              <li
                v-for="(el, index) in requestFilterOption"
                :key="index"
                @click="handleRequestFilter(el)"
              >
                {{ el.text }}
              </li>
            </ul>
          </div>
        </div>

        <div class="list-of-loans-table-container">
          <table class="list-of-loans-table">
            <thead>
              <tr>
                <th class="list-of-loans-table-heading">
                  ID
                </th>
                <th class="list-of-loans-table-heading">
                  BORROWER
                </th>
                <th class="list-of-loans-table-heading">
                  AMOUNT REPAID
                </th>
                <th class="list-of-loans-table-heading">
                  LOAN ID
                </th>
                <th class="list-of-loans-table-heading">
                  DISBURSED DATE
                </th>
                <th class="list-of-loans-table-heading">
                  REPAYMENT DATE
                </th>
                <th class="list-of-loans-table-heading">
                  STATUS
                </th>
                <th class="list-of-loans-table-heading">
                  ACTION
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(loan, index) in listOfDisbursements" :key="index">
                <td class="list-of-loans-table-data">
                  {{ loan && loan.id }}
                </td>
                <td class="list-of-loans-table-data">
                  {{ loan && loan.user }}
                </td>
                <td class="list-of-loans-table-data">
                  ₦
                  {{
                    loan &&
                      new Intl.NumberFormat().format(Number(loan.amount || 0))
                  }}
                </td>
                <td class="list-of-loans-table-data">
                  {{ loan && loan.loanId }}
                </td>
                <td class="list-of-loans-table-data">
                  {{ loan && loan.createdAt | formatDate }}
                </td>
                <td class="list-of-loans-table-data">
                  -
                </td>
                <td class="list-of-loans-table-data">
                  <StatusBadge :status="loan && loan.status" />
                </td>
                <td class="list-of-loans-table-data">
                  <b-dropdown
                    id="dropdown-right"
                    right
                    size="lg"
                    variant="link"
                    toggle-class="text-decoration-none"
                    no-caret
                  >
                    <template v-slot:button-content>
                      <svgicon
                        icon="table-menu"
                        class="dashboard__listing-table-menu"
                      ></svgicon>
                    </template>
                    <b-dropdown-item to="">View</b-dropdown-item>
                  </b-dropdown>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <loader :loader="loader"></loader>
  </div>
</template>
<script>
import loader from "../resuables/loader";
import { getAllDisbursement, getLoanSummary } from "../../../services/loans";
import StatusBadge from "../general/statusBadge.vue";
export default {
  name: "loans",
  components: {
    loader,
    StatusBadge
  },
  data() {
    return {
      filter: { text: "All", value: "all" },
      requestFilter: { value: "all", text: "All Request" },
      showFilterMenu: false,
      showRequestFilterMenu: false,
      currentPage: 1,
      pageSize: 10,
      count: 0,
      pages: 0,
      loader: false,
      listOfDisbursements: [],
      loanSummary: {}
    };
  },
  methods: {
    handleFilter(value) {
      this.filter = value;
      this.showFilterMenu = false;
    },
    handleRequestFilter(value) {
      this.requestFilter = value;
      this.showRequestFilterMenu = false;
    },
    clickaway() {
      if (this.showFilterMenu) {
        this.showFilterMenu = false;
      }
    },

    requestClickaway() {
      if (this.showRequestFilterMenu) {
        this.showRequestFilterMenu = false;
      }
    },
    handleGetLoanSummary() {
      const payload = {
        period: "monthly"
      };

      getLoanSummary(payload)
        .then(res => {
          this.loanSummary = res.data;
        })
        .catch(err => {
          return err;
        });
    },

    getAllDisbursement() {
      this.loader = true;
      const payload = {
        page: this.pages,
        limit: this.pageSize
      };
      getAllDisbursement(payload)
        .then(res => {
          this.listOfDisbursements = res.data.disbursements;
        })
        .catch(err => {
          return err;
        })
        .finally(() => {
          this.loader = false;
        });
    }
  },
  async mounted() {
    window.addEventListener("click", this.clickaway);
    window.addEventListener("click", this.requestClickaway);

    await Promise.all([this.getAllDisbursement(), this.handleGetLoanSummary()]);
  },
  destroyed() {
    window.removeEventListener("click", this.clickaway);
    window.removeEventListener("click", this.requestClickaway);
  },
  computed: {
    filterOption() {
      return [
        { value: "all", text: "All" },
        { value: "monthly", text: "Month" },
        { value: "quarterly", text: "Quarter" },
        { value: "biannually", text: "Biannual" },
        { value: "yearly", text: "Year" }
      ];
    },

    requestFilterOption() {
      return [
        { value: "all", text: "All Request" },
        { value: "pending", text: "Pending Request" }
      ];
    }
  }
};
</script>

<style lang="scss" scoped>
.repayment-container {
  display: grid;
  margin: 30px 10px 20px 10px;

  @media only screen and (min-width: 992px) {
    column-gap: 40px;
    grid-template-columns: 48% 48%;
  }

  .disbursement-container {
    border: 1px solid #e0def7;
    height: 190px;
    border-radius: 8px;
    padding: 20px;

    .inner-elements {
      height: 100%;
      display: grid;
      @media only screen and (min-width: 768px) {
        grid-template-columns: 50% 50%;
      }

      .request-container {
        display: flex;
        justify-content: center;
        align-items: center;

        h3 {
          text-align: center;
          font-size: 22px;
        }

        .link {
          color: #2E48DA;
          font-size: 13px;
          text-decoration: underline;
          cursor: pointer;
        }
      }
    }
  }

  .wallet-container {
    background-color: #2c46cf;
    height: 190px;
    border-radius: 8px;
    padding: 20px;
    margin-top: 20px;

    @media only screen and (min-width: 992px) {
      margin-top: 0;
    }

    .wallet-header {
      line-height: 16px;
      font-weight: 300;
      font-size: 13px;
      color: #ffffff;
    }

    .wallet-value {
      color: #ffffff;
      font-size: 19px;
    }

    .wallet-footer {
      display: flex;
      justify-content: space-between;
      margin-top: 20px;
    }

    hr {
      margin-top: 20px;
      border-top: 1px solid #ffffff;
    }
  }
}
.header {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  height: auto;
  margin-bottom: 16px;

  .table-filter {
    position: relative;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: #0f0c3d;
    cursor: pointer;
    user-select: none;
    margin-right: auto;
    margin-bottom: 10px;
  }

  .filter__wrap {
    position: relative;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: #0f0c3d;
    cursor: pointer;
    user-select: none;
    margin-left: auto;
  }

  .filter-selected {
    background: #fafafe;
    border: 0.4px solid #99a4e1;
    border-radius: 22px;
    padding: 14px;
    width: 128px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: 2px -1px 8px rgba(0, 0, 0, 0.16);

    .filter-icon {
      fill: none;
      width: 10px;
      stroke: rgba(0, 0, 0, 0.4);
      stroke-width: 20px;
      margin-left: 4px;
      transition: all ease 0.25s;

      &.active {
        transform: rotate(180deg);
      }
    }

    .header-filter {
      position: absolute;
      border: 0.4px solid #99a4e1;
      width: 100%;
      border-radius: 6px;
      top: 105%;
      z-index: 2;
      background: white;
      box-shadow: 4px 6px 16px rgba(0, 0, 0, 0.16);

      li {
        padding: 12px 6px;
        border-bottom: 0.4px solid #99a4e1;

        &:last-child {
          border: none;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/loanDisbursement.vue